import axios from "axios";

const service = axios.create({
    baseURL:process.env.VUE_APP_BASE_API,
    timeout: 9000 // 请求超时时间
})

// 请求拦截
service.interceptors.request.use(requestInterceptor,error=> {
    console.error('请求错误', error.response.data);
    return Promise.reject(error.response.data); // 不中断页面操作
})
// 请求拦截函数
function requestInterceptor(config){
    let {headers,method,url,params} = config
    return config
}
//响应拦截
service.interceptors.response.use(response=>response.data,error=> {
    console.error('响应错误', error.response.data);
    return Promise.reject(error.response.data); // 不中断页面操作
})
export default service

